import * as React from 'react';
import { BaseSvg, SVGIconProps } from './BaseSvg';

export const Refresh: React.FC<SVGIconProps> = ({ size = 28, color = 'currentColor', ...props }) => (
  <BaseSvg width={size} height={size} viewBox="0 0 28 28" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.16 4.66666C18.1085 4.66666 22.12 8.84534 22.12 14H24.36C24.36 7.55667 19.3456 2.33333 13.16 2.33333C6.97441 2.33333 1.96 7.55667 1.96 14C1.96 20.4433 6.97441 25.6667 13.16 25.6667C17.0443 25.6667 20.466 23.606 22.4733 20.4823L20.6119 19.1844C19.0026 21.6886 16.2655 23.3333 13.16 23.3333C8.21153 23.3333 4.2 19.1547 4.2 14C4.2 8.84534 8.21153 4.66666 13.16 4.66666Z"
      fill={color}
    />
    <path d="M26.4161 9.33336L21.4155 14.5423L22.9994 16.1922L28 10.9833L26.4161 9.33336Z" fill={color} />
    <path d="M24.5918 14.5452L19.5884 9.33333L18.0045 10.9832L23.0079 16.1951L24.5918 14.5452Z" fill={color} />
  </BaseSvg>
);
